// extracted by mini-css-extract-plugin
export default {"searchBlock":"Search_searchBlock__htScx","clearInput":"Search_clearInput__6Gg37"};